const AUTORISATION_MODAL_STEP = {
	INFORMATIONS_GENERALES: 0,
	CREDITS_PAIEMENT: 1,
	RESSOURCES: 2,
} as const;

export default AUTORISATION_MODAL_STEP;
